import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pln',
  templateUrl: './pln.component.html',
  styleUrls: ['./pln.component.css']
})
export class PlnComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
